<template>
  <span v-if="['inr', ''].includes(type)" class="clr-teal fnt-12">&#8377;</span>
  <span v-else-if="type == 'usd'" class="clr-teal fnt-12">&dollar;</span>
  <span v-else-if="type == 'sgd'" class="clr-teal fnt-12">S&#36;</span>
</template>

<script>
export default {
  name: "Currency",
  props: {
    type: { type: String, default: "inr" }
  }
};
</script>
